import React from 'react'
import {Col, Row} from "react-bootstrap";
import Page from "../../component/Page/Page";
import {Link} from "react-router-dom";
import MobileApplicationsDetailType from "./MobileApplicationsDetailType";
import ByondGrid2 from "../../customGrid/CustomGrid";
import {TitlePage} from "../../component/Page/Title";

function MobileApplicationsScreen() {

  const applicationsDetailType = new MobileApplicationsDetailType();

  return (
    <Page>
      <Row className="my-3">
        <Col md={8} sm={8} lg={8}>
          <TitlePage title="Aplicativos"/>
        </Col>
        <Col md={4} >
          <Link className="btn btn-primary d-flex float-right" to={"/dash/mobile-applications/new"}>Novo</Link>
        </Col>
      </Row>
      <ByondGrid2 endpoint={applicationsDetailType.endpoint()} metadata={applicationsDetailType}/>
    </Page>
  )
}
export default MobileApplicationsScreen;



// WEBPACK FOOTER //
// ./src/pages/MobileApplications/MobileApplicationsScreen.js